<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Customer Complaint Frequency Analysis</b-card-title>
      </b-card-header>
      <apexchart
        type="pie"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "CustomerComplaintAnalysis",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      chartType: 'pie' 
    };
  },
  computed: {
   
    topCustomers() {
      return [...this.data]
        .sort((a, b) => b.complaintCount - a.complaintCount)
        .slice(0, 10);
    },
    series() {
      return this.topCustomers.map(customer => customer.complaintCount); 
    },
    chartOptions() {
      const baseOptions = {
        chart: {
          height: 350,
          type: this.chartType,
          zoom: {
            enabled: false
          },
        },
        labels: this.topCustomers.map(customer => customer.otherName),
        dataLabels: {
          enabled: true
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px'
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} complaints`;
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return `${Math.round(val)}%`;
          }
        },
        colors: ['#F9DF37', '#FFB547', '#FF7F50', '#FF6B6B', '#FA8072', 
                '#FFA07A', '#FFB6C1', '#FFC0CB', '#FFD700', '#FFDAB9']
      };

      return baseOptions;
    }
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  margin: 20px;
}

@media (max-width: 768px) {
  #app {
    margin: 10px;
  }
}
</style>
